import {NextPimField} from "./Catalog/NextPimField";

export enum AiPromptUsage {
    ProductLayer = "ProductLayer",
    Template = "Template"
}

export class AiPrompt {
  constructor(
    public id? :string,
    public name? :string,
    public model? :string,
    public provider? :string,
    public maxLenght? :number,
    public prompt? :string,
    public loadURLsLive?: boolean,
    public useDocumentExtraction?: boolean,
    public nextPimTargetFields?: NextPimField[],
    public usage: AiPromptUsage = AiPromptUsage.ProductLayer
  ) {}
}
